// Copyright (c) Bentley Systems
import { ActionVm } from "../../Action/action-vm";

export class CellVm {
  public value: any;
  public style: string | undefined;
  public action: ActionVm | undefined;
}
